// utils/errorRedirect.js
export const errorRedirection = [
  { statusCode: 401, route: "/not-authorized" },
  { statusCode: 403, route: "/forbidden" },
  { statusCode: 500, route: "/under-maintenance" },
];

export const handleErrorRedirect = (statusCode, navigate) => {
  const foundRoute = errorRedirection.find(
    (route) => route.statusCode === statusCode
  );
  if (foundRoute) {
    navigate(foundRoute.route);
  }
};
